import CsvParserWorker from './csv-parser.worker.ts?worker';

interface ParseSuccessResponse {
  type: 'success';
  data: Record<string, string>[];
}

interface ParseErrorResponse {
  type: 'error';
  error: string;
}

type ParseResponse = ParseSuccessResponse | ParseErrorResponse;

export const parseCsv = (
  csvText: string,
  nodeRange?: { start: number; end: number }
) => {
  return new Promise<Record<string, string>[]>((resolve, reject) => {
    const worker = new CsvParserWorker();

    // Set a timeout to prevent the promise from hanging indefinitely
    const timeout = setTimeout(() => {
      worker.terminate();
      reject(new Error('CSV parsing timed out'));
    }, 30000); // 30 second timeout

    worker.onmessage = (event: MessageEvent<ParseResponse>) => {
      clearTimeout(timeout);

      const response = event.data;

      if (response.type === 'error') {
        worker.terminate();
        reject(new Error(response.error));
        return;
      }

      if (response.type === 'success') {
        resolve(response.data);
        worker.terminate();
        return;
      }

      // Fallback for unexpected response format
      worker.terminate();
      reject(new Error('Unexpected response format from CSV parser worker'));
    };

    worker.onerror = (err) => {
      clearTimeout(timeout);
      worker.terminate();
      reject(
        new Error(
          `Worker error: ${err.message || 'Unknown error occurred in CSV parser worker'}`
        )
      );
    };

    worker.postMessage({ csvText, nodeRange });
  });
};
